module.exports = __webpack_public_path__ + "static/media/galerija_2022_0001.3fae1c1c.jpg";